import { injectable } from 'tsyringe';
import { type ExtensionConfig, ExtensionContext } from "./models/extension-config";

export abstract class Module {

    protected constructor(public dependantModules: Module[]) {
    }
    private _log: ModuleLogger | undefined;
    public get log(): ModuleLogger {
        if (!this._log) {
            this._log = new ModuleLogger(this.name);
        }
        return this._log;
    }
    public abstract name: string;
    public abstract acceptedLicenseFlags: string[];
    public abstract shouldRun(context: ExtensionContext): boolean;
    public abstract run(): Promise<void>;

}
export class Logger {
    public static entries: string[] = [];
}
export class ModuleLogger {

    constructor(private moduleName: string) {

    }
    // this is filled at app.ts with the actual time
    public static pageLoadTime: Date = new Date();
    public static context: ExtensionContext;

    public v(message: string, ...additionalParams: any[]) {
        // get and store the message, but don't display it
        this.getMessage('DBG', message, additionalParams);
    }
    public i(message: string, ...additionalParams: any[]) {
        const msg = this.getMessage('INF', message, additionalParams);
        console.log(msg.formattedMsg, ...msg.additionalParams);
    }
    public w(message: string, ...additionalParams: any[]) {
        const msg = this.getMessage('WRN', message, additionalParams);
        console.warn(msg.formattedMsg, ...msg.additionalParams);
    }
    public e(message: string, ...additionalParams: any[]) {
        const msg = this.getMessage('ERR', message, additionalParams);
        console.error(msg.formattedMsg, ...msg.additionalParams);
    }

    private getMessage(level: string, message: string, additionalParams: any[]): { formattedMsg: string, additionalParams: any[] } {
        const elapsed = Math.round(new Date().getTime() - ModuleLogger.pageLoadTime.getTime());

        const formattedMsg = `[TM-${this.moduleName.replace('Module', '')} ${ModuleLogger.context} ${elapsed}ms ${level}] ${message}`;
        try {
            let totalMessage = [formattedMsg, ...additionalParams.filter(e => !!e).map(p => {
                if (typeof p === 'object' || Array.isArray(p)) {
                    return JSON.stringify(p);
                } else {
                    return p;
                }
            })].join(' ');
            Logger.entries.push(totalMessage);
        } catch (e) {
            console.error('[TM] Failed to process log message', e);
        }

        return { formattedMsg, additionalParams };
    }


}